module.exports = __webpack_public_path__ + "static/media/premiumItem.9a2aa188.svg";